module.exports = {
  API_LOCATION: 'https://nonil9n353.execute-api.us-east-1.amazonaws.com/V1/',
  WAIVER_URL: 'https://offthecouch.io/checkin/',
  BOOKING_URL: 'https://offthecouch.io/book/',
  LEADERBOARD_URL: 'https://offthecouch.io/leaderboard/',
  CDN_URL: 'https://cdn.offthecouch.io/'
}
